export default __webpack_public_path__ + "static/media/account-circle.370e6ff8.svg";